const simpleHash = (str, hashMin = 10) => {
  let hash = 0;
  let valids = "";
  const len = str.length;
  for (let i = 0; i < len; i++) {
    const char = str.charCodeAt(i);
    if (char === 46) {
      valids += "d0t";
    }
    if (isValidCSSCharCode(char) && len <= hashMin) {
      valids += str[i];
    } else {
      hash = (hash << 5) - hash + char;
      hash &= hash;
    }
  }
  return valids + (hash ? new Uint32Array([hash])[0].toString(36) : "");
};
function isValidCSSCharCode(code) {
  return (
    // A-Z
    code >= 65 && code <= 90 || // a-z
    code >= 97 && code <= 122 || // _
    code === 95 || // -
    code === 45 || // 0-9
    code >= 48 && code <= 57
  );
}
export {
  isValidCSSCharCode,
  simpleHash
};
//# sourceMappingURL=index.mjs.map
